document.addEventListener('DOMContentLoaded', function() { // Asigură-te că DOM-ul este complet încărcat
  const readMoreButtons = document.querySelectorAll('.read-more-button');

  readMoreButtons.forEach(button => {
    button.addEventListener('click', function() {
      const longDesc = this.previousElementSibling; // Găsește div-ul cu descrierea lungă
      const shortDesc = this.parentElement.querySelector('.short-desc');

      if (longDesc.style.display === 'none') {
        longDesc.style.display = 'block';
        this.textContent = 'Citeste Mai Puțin'; // Schimbă textul butonului
      } else {
        longDesc.style.display = 'none';
        this.textContent = 'Citeste Mai Mult';
      }
    });
  });
});